export default "__VITE_ASSET__SeATa_OR__"